import React, { useEffect } from 'react'
import { Row, Col, Image, Form, Button, ListGroup, Spinner, InputGroup, } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import Card from '../../../components/Card'
import axios from 'axios'

// img
import facebook from '../../../assets/images/brands/fb.svg'
import google from '../../../assets/images/brands/gm.svg'
import instagram from '../../../assets/images/brands/im.svg'
import linkedin from '../../../assets/images/brands/li.svg'
import auth1 from '../../../assets/images/auth/01.png'
import { userSignal } from '../../../signal/userSignal'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { DEV_SERVER } from '../../../constants/urls'

const SignIn = () => {
   let history = useNavigate()

   const [userName, setUserName] = React.useState('')
   const [password, setPassword] = React.useState('')
   const [showPassword, setShowPassword] = React.useState(false)

   const mutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/loginWithPassword`, data), {
      onSuccess: (data) => {
         let data1 = data.data
         if (data1.status) {
            if(data1.data.user?.userType==="manager"){
               window.localStorage.setItem("sauron-token", data1?.data?.token)
               window.location.href = "/dashboard"
            }else{
               toast.error("You are not authorized to login")
            }
         } else {
            toast.error(data1.message)
         }
      },

      onError: (error) => {  
         if(error.response){
            toast.error(error.response.data.message)
         }else{
            toast.error(error.message)
         }
      }
   })

   const handleLogin = (e) => {
      e.preventDefault()
      mutation.mutate({ userName: userName, password: password })
   }

   useEffect(() => {
      if (userSignal.value !== null) {
         window.location.href = "/dashboard"
      }
   }, [])

   return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <Col md="6">
                  <Row className="justify-content-center">
                     <Col md="10">
                        <Card className="card-transparent shadow-none d-flex justify-content-center mb-0 auth-card">
                           <Card.Body>
                              <Link to="/dashboard" className="navbar-brand d-flex align-items-center mb-3">
                                 <h2 className="logo-title ms-3">Sauron</h2>
                              </Link>
                              <h2 className="mb-2 text-center">Sign In</h2>
                              <p className="text-center">Login to stay connected.</p>
                              <Form onSubmit={handleLogin}>
                                 <Row>
                                    <Col lg="12">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="username" className="">Username</Form.Label>
                                          <Form.Control type="text" className="" id="username" aria-describedby="username" placeholder=" " value={userName} onChange={(e) => setUserName(e.target.value)} />
                                       </Form.Group >
                                    </Col>
                                    <Col lg="12" className="">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="password" className="">Password</Form.Label> 
                                          <InputGroup className="input-group-merge form-password-toggle">
                                             <Form.Control type={showPassword ? "text" : "password"} className="" id="password" placeholder=" " value={password} onChange={(e) => setPassword(e.target.value)} />
                                             <Button onClick={() => setShowPassword(!showPassword)} variant="light" id="password-addon2" type="button" className="input-group-text bg-transparent border-start-0" style={{outline: "none"}}>
                                                <i className="fa fa-eye"></i>
                                             </Button>
                                          </InputGroup>
                                       </Form.Group>
                                    </Col>
                                 </Row>
                                 <div className="d-flex justify-content-center">
                                    {mutation.isLoading ? <Button variant="primary" type="button" disabled>
                                       <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
                                       Loading...
                                    </Button> :
                                       <Button type="submit" variant="btn btn-primary">Sign In</Button>
                                    }
                                 </div>
                              </Form>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
                  <div className="sign-bg">
                     <svg width="280" height="230" viewBox="0 0 431 398" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.05">
                           <rect x="-157.085" y="193.773" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 -157.085 193.773)" fill="#3B8AFF" />
                           <rect x="7.46875" y="358.327" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 7.46875 358.327)" fill="#3B8AFF" />
                           <rect x="61.9355" y="138.545" width="310.286" height="77.5714" rx="38.7857" transform="rotate(45 61.9355 138.545)" fill="#3B8AFF" />
                           <rect x="62.3154" y="-190.173" width="543" height="77.5714" rx="38.7857" transform="rotate(45 62.3154 -190.173)" fill="#3B8AFF" />
                        </g>
                     </svg>
                  </div>
               </Col>
               <Col md="6" className="d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Image src={auth1} className="Image-fluid gradient-main animated-scaleX" alt="images" />
               </Col>
            </Row>
         </section>
      </>
   )
}

export default SignIn
